import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { CartProvider } from "./context/CartContext";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { ActivitiesProvider } from "./context/ActivitiesContext";
import { AuthProvider } from "./context/AuthContext";


import "leaflet/dist/leaflet.css"; // Leaflet 样式
import L from "leaflet";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});


const root = ReactDOM.createRoot(document.getElementById("root"));
serviceWorkerRegistration.register();
root.render(
  <React.StrictMode>
    <div className="frontend">
      <ActivitiesProvider>
        <AuthProvider>
          <CartProvider>
            {/* Add ActivitiesProvider */}
            <App />
          </CartProvider>
        </AuthProvider>
      </ActivitiesProvider>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
